export default "__VITE_ASSET__DNioFuCW__"